/* eslint-disable react/display-name */
import React, { useMemo, useState } from 'react';
import Styles from './Select.css';
import TextField from '../TextField/TextField';
import clsx from 'clsx';
import ClickAwayListener from 'react-click-away-listener';
import { useLockPageScroll } from '../../../../utils/useLayout';

/**
 *
 * @type {import('../../../../../types/SimuladorEnergiaSolar').SelectComponent}
 */
const Select = React.forwardRef(
  (
    {
      options = [],
      handleValueChange,
      value,
      allowClear,
      onChange,
      lockPageScroll,
      singleLine = false,
      ...props
    },
    ref,
  ) => {
    const [search, setSearch] = useState('');
    const [showOptions, setShowOptions] = useState(false);

    useLockPageScroll(lockPageScroll && showOptions);

    const renderOptions = useMemo(() => {
      const filtered = options.filter((option) =>
        option.label.toLowerCase().includes(search.toLowerCase()),
      );

      // return [{ label: props.label, value: '', disabled: true }, ...filtered];
      return filtered;
    }, [options, search]);

    const displayValue = useMemo(() => {
      if (showOptions && !search) return '';

      return search || options.find((option) => option.value === value)?.label || '';
    }, [options, search, showOptions, value]);

    const showClear = allowClear && value;

    const updateValue = (v = '') => {
      setSearch('');
      setShowOptions(false);
      handleValueChange(v);
    };

    return (
      <>
        <ClickAwayListener
          onClickAway={() => {
            setShowOptions(false);
            setSearch('');
          }}
        >
          <div
            className={clsx({
              'select-field': true,
              'show-clear': showClear,
              'single-line': singleLine,
            })}
          >
            <TextField
              {...props}
              ref={ref}
              autoComplete="off"
              aria-autocomplete="none"
              type="text"
              value={displayValue}
              onChange={(ev) => {
                ev.preventDefault();
                setSearch(ev.target.value);
              }}
              onFocus={(ev) => {
                if (props.onFocus) {
                  props.onFocus(ev);
                }

                setTimeout(() => {
                  setShowOptions(true);
                }, 75);
              }}
              endAdornment={
                <>
                  {showClear && (
                    <img
                      src="assets/simulador-energia-solar/jornada/ic-clear.svg"
                      alt="limpar"
                      role="button"
                      onClick={(ev) => {
                        ev.preventDefault();
                        updateValue('');
                      }}
                    />
                  )}

                  {!showClear && (
                    <img src="assets/simulador-energia-solar/jornada/ic-dropdown.svg" alt="" />
                  )}
                </>
              }
              data-selected={value}
            />

            <div
              className={clsx({
                'select-element': true,
                active: showOptions,
              })}
            >
              {renderOptions.map((option) => (
                <div
                  className={clsx({
                    'option-element': true,
                    disabled: option.disabled,
                    selected: option.value === value,
                  })}
                  key={option.value}
                  value={option.value}
                  onClick={(ev) => {
                    ev.preventDefault();
                    if (option.disabled) return;

                    updateValue(option.value);
                  }}
                >
                  <p>{option.label}</p>
                </div>
              ))}
            </div>
          </div>
        </ClickAwayListener>
        <style jsx>{Styles}</style>
      </>
    );
  },
);

export default Select;
